// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-text',
    // #endregion
    // #region Properties
    props: {
        content: {
            type: Object,
            required: true,
            default: {}
        },
    },
    // #endregion
});
// #endregion
